import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/production/inferior',
    name: 'PUT_PRODUCTION_INFERIOR',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
